import React, { useState } from "react"
import { Box, Text, Container, Heading } from "@theme-ui/components"
import {
  MapContainer,
  TileLayer,
  CircleMarker,
  Popup,
  MapConsumer,
} from "react-leaflet"
import "leaflet/dist/leaflet.css"
import MarkerClusterGroup from "react-leaflet-markercluster"
import "react-leaflet-markercluster/dist/styles.min.css"
import styled from "styled-components"
const LocationsMap = ({ locations, title }) => {
  const [map, setMap] = useState()
  const locationBounds = locations.map(city => [
    city.coordinates.latitude,
    city.coordinates.longitude,
  ])
  console.log(locations)
  const CustomMarkerClusterGroup = styled(MarkerClusterGroup)`
    .marker-cluster-small {
      background-color: #9c73ff !important;
    }

    .marker-cluster-small div {
      background-color: #9c73ff !important;
    }

    .marker-cluster-small span {
      color: white !important;
    }
  `

  return (
    <Box
      sx={{
        display: ["none", "none", "block", "block"],
        height: "100vh",
        ".leaflet-container": { height: "100%" },
        ".marker-cluster": {
          backgroundColor: "#9c73ff",
          div: {
            backgroundColor: "#9c73ff",
            color: "white",
          },
        },
        ".leaflet-popup-content-wrapper": {
          borderRadius: "20px",
          boxShadow: "unset",
          fontSize: "16px",
          border: "1px solid",
          borderColor: "#1DDDDD",
          minWidth: "350px",
          minHeight: "100px",
        },
        ".leaflet-popup-tip-container": {
          display: "none",
          p: {
            margin: "0px!important",
          },
        },
        ".leaflet-popup-content p": {
          margin: "0px!important",
        },
        ".leaflet-container a.leaflet-popup-close-button": {
          backgroundColor: "black",
          borderRadius: "50%",
          top: "10px",
          right: "10px",
          width: "30px",
          height: "30px",
          a: {
            borderRadius: "50%",
            backgroundColor: "black",
          },
          span: {
            fontWeight: 200,
            display: "inline-block",
            fontSize: "30px",
            height: "100%",
            width: "100%",
            borderRadius: "50%",
            color: "white",
            backgroundColor: "dark",
          },
        },
      }}
    >
      <Container>
        <Heading variant="h3" sx={{ my: 4 }}>
          {title}
        </Heading>
      </Container>
      {typeof window !== "undefined" && (
        <MapContainer
          scrollWheelZoom={false}
          zoomControl={true}
          bounds={locationBounds}
          tap={false}
        >
          <TileLayer url="https://api.mapbox.com/styles/v1/multiconsult/clypfqqj5006t01pihn6ha24e/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoibXVsdGljb25zdWx0IiwiYSI6ImNseXBmZWtkOTB0YXQya3F5M3c1cnhrOTQifQ.HHSRcmfAQaP472CEhniP7Q" />
          <CustomMarkerClusterGroup showCoverageOnHover={false}>
            {locations.map(city => (
              <CircleMarker
                key={city.originalId}
                center={[city.coordinates.latitude, city.coordinates.longitude]}
                radius={20}
                fillColor="#9C73FF"
                color="#9C73FF"
                weight={2}
                opacity={1}
                fillOpacity={0.5}
              >
                <Popup>
                  <Text
                    sx={{
                      fontSize: "16px",
                      fontWeight: 500,
                      textTransform: "uppercase",
                    }}
                  >
                    {city.name}{" "}
                  </Text>
                  <Text
                    as="p"
                    sx={{
                      fontSize: "14px",
                      fontWeight: 400,
                      textTransform: "capitalize",
                    }}
                  >
                    {city.streetAddress}
                  </Text>
                  <Text
                    as="p"
                    sx={{
                      my: "0px!immportant",
                      fontSize: "14px",
                      fontWeight: 400,
                      textTransform: "capitalize",
                    }}
                  >
                    {city.postalCode}
                  </Text>
                </Popup>
              </CircleMarker>
            ))}
          </CustomMarkerClusterGroup>
          <MapConsumer>
            {map => {
              setMap(map)
              return null
            }}
          </MapConsumer>
        </MapContainer>
      )}
    </Box>
  )
}

export default LocationsMap
